<template>
  <main id="platform-admin" v-if="isReady">
    <PlatformAdminLayoutMenu/>
    <div class="content">
      <RouterView/>
    </div>
  </main>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import PlatformAdminLayoutMenu from './components/PlatformAdminLayoutMenu.vue';
import { useAxios } from '@/api/axios';
import { AxiosResponse } from 'axios';
import { platformAdmin } from '@/global/states/PlatformAdminState';
import router from '@/router';
import { PlatformAdminModel } from '@/models/PlatformAdminModel';

const isReady = ref<boolean>(false)
const axios = useAxios()

onMounted(() => {
  axios.get('/api/platform-admin/me').then((response: AxiosResponse<PlatformAdminModel>) => {
    platformAdmin.value = response.data
    isReady.value = true
  }).catch(() => {
    router.push({ name: 'platform-admin.login' })
  })
})
</script>

<style lang="scss">
  #platform-admin{
    width: 100%;
    min-height: 100dvh;
    display: flex;
    flex-direction: column;
    background: var(--VERDE-BACKGROUND, #F5F8F7);
    .content{
      width: 100%;
      display: flex;
      justify-content: center;
      padding: 32px 24px 60px;
      box-sizing: border-box;
    }
  }
</style>
